module.exports = __webpack_public_path__ + "img/img29.c70204b5.png";